export default __webpack_public_path__ + "static/media/12.4f475ef1.jpg";